import React from 'react';
import {
  Radio as MuiRadio,
  RadioProps as MuiRadioProps,
} from '@mui/material';

import RadioChechedIcon from "../../../components/icons/radioChechedIcon";

export type RadioProps = MuiRadioProps;

const Radio  = function Radio({
  ...rest
}: RadioProps) {
  return (
    <MuiRadio checkedIcon={<RadioChechedIcon/>} {...rest}/>
  );
}

export default Radio;

